import { logWarning } from 'src/_shared/logger';
import {
  CUSTOM_FONTS,
  CustomFontName,
  DEFAULT_LATO_FONT_STYLE_KEY,
  DEFAULT_WORK_SANS_FONT_STYLE_KEY,
  FontStyle,
  MAIN_FONTS,
  MainFontName,
} from 'src/constants/font.constants';

export const getAvailableCustomFontStyles = (font?: CustomFontName | string | null): FontStyle[] => {
  return font ? (Object.keys(CUSTOM_FONTS[font as CustomFontName] ?? {}) as FontStyle[]) : [];
};

export const getLatoFontFamily = (fontStyle: FontStyle): string => {
  const latoFontInfo = MAIN_FONTS[MainFontName.Lato][fontStyle];
  return !!latoFontInfo?.key ? `${latoFontInfo.key}, ${DEFAULT_LATO_FONT_STYLE_KEY}` : DEFAULT_LATO_FONT_STYLE_KEY;
};

export const getWorkSansFontFamily = (fontStyle: FontStyle): string => {
  const workSansFontInfo = MAIN_FONTS[MainFontName.WorkSans][fontStyle];
  return !!workSansFontInfo?.key
    ? `${workSansFontInfo.key}, ${DEFAULT_WORK_SANS_FONT_STYLE_KEY}`
    : DEFAULT_WORK_SANS_FONT_STYLE_KEY;
};

export const getCustomFontFamily = (fontName: string, fontStyleName: string): string => {
  let customFontFamily = DEFAULT_LATO_FONT_STYLE_KEY;
  if (
    CUSTOM_FONTS[fontName as CustomFontName] &&
    CUSTOM_FONTS[fontName as CustomFontName][fontStyleName as FontStyle] &&
    !!CUSTOM_FONTS[fontName as CustomFontName][fontStyleName as FontStyle]?.key
  ) {
    customFontFamily = `${CUSTOM_FONTS[fontName as CustomFontName][fontStyleName as FontStyle]!.key}, ${DEFAULT_LATO_FONT_STYLE_KEY}`;
  } else {
    logWarning('[Font] Font not found', { CUSTOM_FONTS, fontName, fontStyleName });
  }

  return customFontFamily;
};
